import { Button, Col, Drawer, Form, Input, message, Row, Space } from "antd";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import confirmBooking from "../../../../services/confirmBooking";
import fetchAllUsers from "../../../../services/fetchAllUsers";

export default function ConfirmPanel({
  isVisible,
  selected,
  refetch,
  setConfirmModal,
}: any) {
  const [form] = Form.useForm();
  const [users, setUsers] = useState<any>([]);

  const onSubmit = async () => {
    const { wip, assignedTo } = form.getFieldsValue();
    const data = {
      status: "Confirmed",
      name: selected?.customer_name,
      mobile: selected?.customer_mobile,
      wip,
    };
    const booking_id = selected?.extendedProps?._id;
    const response = await confirmBooking(data, booking_id);
    if (response.success === false) {
      message.error("Something went wrong");
    } else {
      if (response.success) {
        message.success("Updated Successfully");
        refetch();
        form.resetFields();
        hideModal();
      } else {
        message.error(response.message);
      }
    }
    setConfirmModal(false);
    await refetch();
  };

  const hideModal = () => {
    setConfirmModal(false);
  };

  const handleFetchUsers = async () => {
    const response = await fetchAllUsers();
    const filtered = response?.payload.filter(
      (item: any) => item.isActive && !item.isDealer
    );
    setUsers(response?.payload);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
    handleFetchUsers();
  }, [selected]);

  return (
    <Drawer
      title={`CONFIRM BOOKING`}
      placement={"right"}
      width={800}
      onClose={() => setConfirmModal(false)}
      visible={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setConfirmModal(false)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <Form
        id="UpdateBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="wip"
              rules={[
                {
                  required: true,
                  message: "Please enter WIP Number",
                },
              ]}
            >
              <Input placeholder="WIP / Booking Number" />
            </Form.Item>
          </Col>
        </Row>

        <div className="mt-4">
          <Form.Item>
            <Button danger type="primary" htmlType="submit">
              Submit
            </Button>
            <Button htmlType="button" className="mx-2" onClick={clearForm}>
              Reset
            </Button>
            <Button htmlType="button" className="mx-2" onClick={hideModal}>
              Close
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Drawer>
  );
}
